
import { login, logout, getInfo, getUserInfo } from '@/api/user'
import { getToken, setToken, removeToken, setRefreshToken, removeRefreshToken } from '@/utils/auth'
import router, { resetRouter } from '@/router'
const localUserInfo = localStorage.getItem('hsapp:userinfo')
const adminNickname = localStorage.getItem('hsapp:adminuser')
const state = {
  token: getToken(),
  username: adminNickname,
  avatar: '',
  introduction: '',
  roles: [],
  userinfo: localUserInfo ? JSON.parse(localUserInfo) : ''
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    localStorage.setItem('hsapp:adminuser', name)
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_USERINFO: (state, userinfo) => {
    state.userinfo = userinfo
  }
}

const actions = {
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({
        username: username,
        password: password,
        grant_type: 'password',
        client_id: 'youlai-admin',
        loginType: 8,
        client_secret: '123456'
      }).then(response => {
        const { token, refreshToken } = response.data
        commit('SET_TOKEN', token)
        setToken(token)
        setRefreshToken(refreshToken)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  refreshToken({ commit }, refreshToken) {
    commit('SET_TOKEN', undefined)
    return new Promise((resolve, reject) => {
      login({
        grant_type: 'refresh_token',
        refresh_token: refreshToken,
        client_id: 'youlai-admin',
        client_secret: '123456'
      }).then(response => {
        const { token, refreshToken } = response.data
        commit('SET_TOKEN', token)
        setToken(token)
        setRefreshToken(refreshToken)
        resolve(token)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getUserInfo({ commit }, params) {
    const { userId } = params
    return new Promise((resolve, reject) => {
      getUserInfo({ userId }).then(res => {
        commit('SET_USERINFO', res.data)
        window.localStorage.setItem('hsapp:userinfo', JSON.stringify(res.data))
      }).catch(err => {
        reject(err)
      })
    })
  },
  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        const { data } = response

        if (!data) {
          reject('token信息验证失败，请重新登陆')
        }

        const { roles, nickname, avatar, introduction } = data

        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!')
        }

        commit('SET_ROLES', roles)
        commit('SET_NAME', nickname)
        commit('SET_AVATAR', avatar)
        commit('SET_INTRODUCTION', introduction)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        removeToken()
        removeRefreshToken()
        resetRouter()

        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        dispatch('tagsView/delAllViews', null, { root: true })

        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      removeRefreshToken()
      resolve()
    })
  },

  // dynamically modify permissions
  async changeRoles({ commit, dispatch }, role) {
    const token = role + '-token'

    commit('SET_TOKEN', token)
    setToken(token)

    const { roles } = await dispatch('getInfo')

    resetRouter()

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })
    // dynamically add accessible routes
    router.addRoutes(accessRoutes)

    // reset visited views and cached views
    dispatch('tagsView/delAllViews', null, { root: true })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

